const sites = () => [
  {
    name: 'ALBANY',
    id: 1
  },
  {
    name: 'CHARTWELL',
    id: 2
  },
  {
    name: 'COLOMBO',
    id: 3
  },
  {
    name: 'DUNEDIN',
    id: 4
  },
  {
    name: 'FERRY ROAD',
    id: 5
  },
  {
    name: 'GLEN INNES',
    id: 6
  },
  {
    name: 'KAHIKATEA DRIVE',
    id: 7
  },
  {
    name: 'LOWER HUTT',
    id: 8
  },
  {
    name: 'MANUKAU',
    id: 9
  },
  {
    name: 'MT ROSKILL',
    id: 10
  },
  {
    name: 'NORTHCOTE',
    id: 11
  },
  {
    name: 'ONEHUNGA',
    id: 12
  },
  {
    name: 'PAPAKURA',
    id: 13
  },
  {
    name: 'PORIRUA',
    id: 14
  },
  {
    name: 'PUKEKOHE',
    id: 15
  },
  {
    name: 'QUAYSIDE',
    id: 16
  },
  {
    name: 'SHIRLEY',
    id: 17
  },
  {
    name: 'TE NGAE',
    id: 18
  },
  {
    name: 'UPPER HUTT',
    id: 19
  },
  {
    name: 'WANGANUI',
    id: 20
  }
];

export default sites;
